







































import { ScreenText } from '@/lang/ScreenText'
import ErrorModal from '@/popupcomponents/ErrorModal.vue'
import cart from '@/store/modules/checkout/cart/module'
import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator'
import Spinner from '@/commoncomponents/spinner/Spinner.vue'
import UIkit from 'uikit'
import APP_CONST from '@/constants/AppConst'
import AccountSettings from '@/mixins/accountSettings.mixin'

@Component({
  components: {
    Spinner,
    ErrorModal
  }
})
export default class AgeRestrictionAlert extends Mixins(AccountSettings) {
  @Prop() isScholarSelectionShowing!: boolean
  @PropSync('isVisible', { type: Boolean, required: true }) isVisibleSync!: boolean

  public readonly screenText = new ScreenText()
  APP_CONST = APP_CONST

  get removalInProgress(): boolean {
    return cart.isDeleting || cart.isUpdatingCart
  }

  changeParticipant() {
    this.$emit('changeParticipant')
  }

  removeApplication() {
    this.$emit('removeApplication')
  }

  mounted() {
    UIkit.util.on(this.$el, 'hidden', () => {
      this.$emit('closeModal')
    })
  }
}
